import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Ui::Page data-test-map-index>\n  {{outlet}}\n</Ui::Page>",{ moduleName: "garaje/pods/spaces/maps/template.hbs" })